export default __webpack_public_path__ + "static/media/develop_plate.cbb5dd7d.png";